export default __webpack_public_path__ + "static/media/menu-icon-light.bd9be862.svg";